export const generateSingularLabel = (pluralLabel: string, value: number) => {
  if (value !== 1) {
    return pluralLabel;
  }

  switch (pluralLabel) {
    case "Events":
      return "Event";
    case "Viewings":
      return "Viewing";
    case "attendees":
      return "attendee";
    case "Hot buyers":
      return "Hot buyer";
    case "Warm buyers":
      return "Warm buyer";
    case "Total attendees":
      return "Total attendee";
    case "Private inspections":
      return "Private inspection";
    case "Open homes":
      return "Open home";
    case "Who have attended twice":
      return "Has attended twice";
    case "Total ad clicks":
      return "Total ad click";
    case "Enquiries":
      return "Enquiry";
    case "Newsletters sent":
      return "Newsletter sent";
    case "Days since listing the property":
      return "Day since listing the property";

    default:
      return pluralLabel;
  }
};
